const labels: Record<string, string> = {
  A_FAIRE: 'À faire',
  EN_COURS: 'En cours',
  EN_ATTENTE: 'En attente',
  BLOQUEE: 'Bloquée',
  A_ARBITRER: 'À arbitrer',
  A_VALIDER: 'À valider',
  VALIDEE: 'Validée',
  ARCHIVEE: 'Archivée',
  ANNULEE: 'Annulée',
  BROUILLON: 'Brouillon',
  SOUMISE: 'Soumise',
  A_EXAMINER: 'À examiner',
  COMPLEMENT_DEMANDE: 'Complément demandé',
  ACCEPTEE: 'Acceptée',
  PLANIFIEE: 'Planifiée',
  REFUSEE: 'Refusée',
  RETIREE: 'Retirée',
  TRAITEE: 'Traitée',
  BASSE: 'Basse',
  NORMALE: 'Normale',
  HAUTE: 'Haute',
  CRITIQUE: 'Critique',
  LUE: 'Lue',
  NON_LUE: 'À lire',
  ENVOYE: 'Envoyé',
  NON_DEMANDE: 'Non demandé',
  DESACTIVE: 'Désactivé',
  CONNECTE: 'Connecté',
  NON_CONNECTE: 'Non connecté',
  CONNECTEE: 'Connectée',
  DECONNECTEE: 'Déconnectée',
  NON_CONFIGUREE: 'Non configurée',
  PUBLIE: 'Publié',
  OUVERT: 'Ouvert',
  PRIS_EN_CHARGE: 'Pris en charge',
  CONTENU: 'Contenu',
  RESOLU: 'Résolu',
  MINEUR: 'Mineur',
  MAJEUR: 'Majeur',
  INFORMATION: 'Information',
  OUT_OF_SCOPE: 'Hors périmètre',
  DECISION: 'Décision',
  ACTION_PROPOSEE: 'Action proposée',
  PROPOSAL_SUBMITTED: 'Proposition soumise',
  OPERATIONS_CRITICAL: 'Opération critique',
  ACTION_DUE_SOON: 'Action bientôt échue',
  ACTION_OVERDUE: 'Action en retard',
  ACTION_BLOCKED: 'Action bloquée',
  ECHEC: 'Échec',
  EMAIL: 'Email',
  ACTION: 'Action',
  REUNION: 'Réunion',
  SUJET_REPORTE: 'Sujet reporté',
};

export function humanLabel(value: string | null | undefined) {
  if (!value) return 'Non renseigné';
  const key = value.toLocaleUpperCase('fr-FR').replaceAll('.', '_');
  return (
    labels[key] ??
    value
      .toLocaleLowerCase('fr-FR')
      .replaceAll('_', ' ')
      .replaceAll('.', ' ')
      .replace(/^./, (c) => c.toLocaleUpperCase('fr-FR'))
  );
}

export function statusTone(value: string) {
  if (['CRITIQUE', 'ECHEC', 'REFUSEE', 'BLOQUEE', 'ANNULEE'].includes(value)) return 'danger';
  if (['HAUTE', 'A_VALIDER', 'A_ARBITRER', 'A_EXAMINER', 'COMPLEMENT_DEMANDE'].includes(value))
    return 'warning';
  if (['VALIDEE', 'ACCEPTEE', 'PLANIFIEE', 'TRAITEE', 'ENVOYE'].includes(value)) return 'success';
  return 'neutral';
}

export function formatDateTime(value: string | null | undefined, empty = 'Sans date') {
  if (!value) return empty;
  return new Intl.DateTimeFormat('fr-FR', {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone: 'Europe/Paris',
  }).format(new Date(value));
}

export function safeUserTitle(value: unknown, fallback = 'Événement ALBA') {
  if (typeof value !== 'string' && typeof value !== 'number') return fallback;
  const title = String(value)
    .replace(/\b[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\b/gi, '')
    .replace(/\s{2,}/g, ' ')
    .replace(/[\s:,-]+$/g, '')
    .trim();
  return title || fallback;
}
